//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";
(function() {
	angular.module('pphhApp')
		.factory("CRUDService", ["$http", "$window", "$q", "pphhEnv", CRUDServiceFactory]);

	function CRUDServiceFactory($http, $window, $q, pphhEnv) {

		return {
			navIndex: function() {
				return $http.get(_contextPath + "/crud/navIndex");
			},

			menu: function() {
				return $http.get(_contextPath + "/crud/menu");
			},

			menuRow: generateMenu,

			initFilter: initFilter,
			filter: filter,

			initForm: initForm,

			getStoredFilters: getStoredFilters,
			storeFilter: storeFilter,
			deleteStoredFilters: deleteStoredFilters,
			changeGlobalFeature: changeGlobalFeature,

			download: download,

			changeViewMode: changeViewMode,

			saveInstance: saveInstance,

			deletePreconditions: function(entityName, id) {
				return $http.get("/crud/" + entityName + "/" + id + "/delete-init");
			},

			deleteInstance: deleteInstance,

			transition: transition,

			lockCiclo: lockCiclo,

			closeCiclo: closeCiclo,
			versionCopy:versionCopy,
			onChange: onChange,

			moduleCarousel: function() {
				return $http.get("/crud/moduleCarousel/modules");
			},

			switchModuleCarousel: function(moduleKey) {
				$window.location.href = _contextPath + "/crud/moduleCarousel/changeTo/" + moduleKey;
			},
			uploadImagenFile : uploadImagenFile,
		}

		function initFilter(entityName) {
			var deferred = $q.defer();

			$http.get("/crud/" + entityName + "/filter-init")
				.then(function(response) {
					deferred.resolve(response);
				}, function(response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function filter(entityName, filterObj, page, sort) {
			var deferred = $q.defer();

			var ret = filterToForm(filterObj);
			ret["__page__"] = page;
			if (sort) {
				ret["__sort__"] = sort.predicate;
				ret["__s_asc__"] = !sort.reverse;
			}
			var request = {
				method: "GET",
				url: _contextPath + "/crud/" + entityName + "/filter",
				params: ret
			};
			$http(request)
				.then(function(response) {
					var responseFinal = {};
					responseFinal.resultados = response.data;
					if (responseFinal.resultados.results) {
						var queryResults = responseFinal.resultados.results;
						responseFinal.menus = [];
						angular.forEach(queryResults, function(value, key) {
							generateMenu(value, entityName)
								.then(function(responseMenu) {
									responseFinal.menus[value.data.id] = responseMenu.data;
								}, function(response) {
									deferred.reject(response);
								});
						});
					}

					deferred.resolve(responseFinal);
				}, function(response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function filterToForm(filterObj, formatDates) {
			var ret = {};
			angular.forEach(filterObj, function(filterField, filterFieldName) {
				if ((filterField.value == null || filterField.value === "")
					&& (filterField.upperValue == null || filterField.upperValue === "")
					&& filterField.storedFilterKey == null) {
					return;
				}
				if (filterField.value != null) {
					if (filterField.date && formatDates) {
						ret[filterFieldName] = moment(filterField.value).utc().format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
					} else {
						ret[filterFieldName] = filterField.value;
					}
				}

				if (filterField.storedFilterKey) {
					ret[filterFieldName + "__sf"] = filterField.storedFilterKey;
				}

				ret[filterFieldName + "__op"] = filterField.comparisionType;

				if (filterField.description) {
					ret[filterFieldName + "__description"] = filterField.description;
				}

				if (filterField.upperValue) {
					if (filterField.date && formatDates) {
						ret[filterFieldName + "__upper"] = moment(filterField.upperValue).utc().format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
					} else {
						ret[filterFieldName + "__upper"] = filterField.upperValue;
					}
				}
			});
			return ret;
		}

		function getStoredFilters() {
			var request = {
				method: "GET",
				url: _contextPath + "/crud/storedFilters/filters"
			};
			return $http(request);
		}

		function storeFilter(name, entityName, filterObj) {
			var ret = filterToForm(filterObj);
			ret["_persistent_filter_name_"] = name;

			var request = {
				method: "POST",
				url: "/crud/" + entityName + "/filter/persist",
				params: ret
			};

			return $http(request);
		}

		function deleteStoredFilters(storedFilter) {
			var request = {
				method: "DELETE",
				url: _contextPath + "/crud/storedFilters/" + storedFilter.key
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}

		function changeGlobalFeature(storedFilter) {
			var request = {
				method: "POST",
				url: _contextPath + "/crud/storedFilters/" + storedFilter.key,
				data: {
					global: storedFilter.global
				}
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}

		function changeViewMode(entityName, readonly, id) {
			var request = {
				method: "POST",
				url: "/crud/changemode",
				data: {
					readonly: readonly,
					entityName: entityName,
					instanceId: id
				}
			};
			return $http(request);
		}

		function initForm(entityName, id) {
			if (id == "") {
				return $http.get(_contextPath + "/crud/" + entityName + "/form-init");
			} else {
				return $http.get(_contextPath + "/crud/" + entityName + "/" + id + "/form-init");
			}
		}

		function saveInstance(entityName, id, form) {
			var url = null;
			if (!id) {
				url = _contextPath + "/crud/" + entityName;
			} else {
				url = _contextPath + "/crud/" + entityName + "/" + id;
			}

			var formData = {};
			for (var fieldName in form) {
				if (form.hasOwnProperty(fieldName)) {
					formData[fieldName] = form[fieldName].value;
				}
			}

			var request = {
				method: "POST",
				url: url,
				data: formData
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}

		function deleteInstance(entityName, id) {
			var url = _contextPath + "/crud/" + entityName + "/" + id;
			var request = {
				method: "DELETE",
				url: url
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}

		function download(entityName, filterData, sort) {
			var ret = filterToForm(filterData, true);
			if (sort) {
				ret["__sort__"] = sort.predicate;
				ret["__s_asc__"] = !sort.reverse;
			}

			var url = pphhEnv.global.contextPath + "/crud/" + entityName + "/export";
			var i = 0;
			for (var p in ret) {
				if (ret.hasOwnProperty(p)) {
					var value = null;
					if (!Array.isArray(ret[p])) {
						value = [];
						value[value.length] = ret[p];
					} else {
						value = ret[p];
					}

					for (var j = 0; j < value.length; j++) {
						if (i == 0) {
							url += "?";
						} else {
							url += "&";
						}
						url += p + "=" + value[j];

						i++;
					}
				}
			}

			$window.open(url);
		}

		function onChange(entityName, id, form, fieldName) {
			var url = null;
			if (!id) {
				url = _contextPath + "/crud/" + entityName;
			} else {
				url = _contextPath + "/crud/" + entityName + "/" + id;
			}
			url += "/c/" + fieldName;

			var formData = {};
			for (var formField in form) {
				if (form.hasOwnProperty(formField)) {
					formData[formField] = form[formField].value;
				}
			}

			var request = {
				method: "POST",
				url: url,
				data: formData
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}

		function transition(entityName, id, actionId, notificationText) {
			var url = _contextPath + "/pphhNav/activity-transition/" + actionId;
			var request = {
				method: "POST",
				url: url,
				data: {
					entityName: entityName,
					id: id, 
					notificationText: notificationText
				}
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}

		function lockCiclo(value) {
			var url = _contextPath + "/pphhNav/ciclo-lock";
			if (!value) {
				url = _contextPath + "/pphhNav/ciclo-unlock";
			}
			var request = {
				method: "POST",
				url: url
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}

		function closeCiclo(params) {
			var url = _contextPath + "/pphhNav/ciclo-close";
			var request = {
				method: "POST",
				url: url
			};
			if (params) {
				request.data = params;
			}
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}
		
		function versionCopy(params) {
			var url = _contextPath + "/pphhNav/version-copy";
			var request = {
				method: "POST",
				url: url
			};
			if (params) {
				request.data = params;
			}
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			return $http(request);
		}		

		function generateMenu(row, entityName) {
			return $http.get(_contextPath + "/crud/" + entityName + "/" + row.data.id + "/menuRow");

		}
		
		function uploadImagenFile(file,id,entityName,fieldName) {
			var deferred = $q.defer();
			var formData = new FormData();
			formData.append("file", file);
			formData.append("id", id);
			formData.append("fieldName", fieldName);
			formData.append("entityName", entityName);
			
			var request = {
					method: "POST",
					url: _contextPath + "/crud/resource/imagen/",
					data: formData,
					transformRequest: angular.identity
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			request.headers["Content-type"] = undefined;

			$http(request).then(
					function(res) {
						deferred.resolve(res.data);
					},
					function(msg) {
						deferred.reject(msg.data);
					});
			return deferred.promise;
		}
	}
})();
